// extracted by mini-css-extract-plugin
export default {"colors":"colors-K33q","color":"color-D_BH"};